export default __webpack_public_path__ + "static/media/AR.ee700075.png";